// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectImage_container__Y_ppU","image":"ProjectImage_image__sg2rC"};